import { render, staticRenderFns } from "./wtEditWithAiButton.vue?vue&type=template&id=2b27ca90&scoped=true&"
import script from "./wtEditWithAiButton.vue?vue&type=script&lang=js&"
export * from "./wtEditWithAiButton.vue?vue&type=script&lang=js&"
import style0 from "./wtEditWithAiButton.vue?vue&type=style&index=0&id=2b27ca90&lang=scss&scoped=true&"
import style1 from "./wtEditWithAiButton.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b27ca90",
  null
  
)

export default component.exports